<template>
    <div>
        <div class="modal-header">
            <h2 class="text-center">Der er mere end et lag</h2>
        </div>

        <p class="text-center">Vælg venligst et lag for at forsætte med at redigere attributter.</p>
        <select v-model="selected">
            <option v-for="(value, index) in data.layers" :value="value" :key="index">
            {{value}}
            </option>
            <option value="" hidden>Vælg et lag</option>
        </select>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="continueEdit()">Forsæt</button>
                <button type="button" class="button-naked" @click="closeModal()">Luk</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'requisition-modal-layers',
    props: [
        'data'
    ],
    data () {
        return {
            selected: ''
        }
    },
    methods: {
        closeModal () {
            this.$emit('close')
        },
        continueEdit () {
            this.$emit('close')
            this.data.openAttributeModal(this.selected)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/requisition/requisition-modal-layers.vue